"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _atomize = _interopRequireDefault(require("@quarkly/atomize"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Message = _atomize["default"].div();

var ComponentNotice = function ComponentNotice(_ref) {
  var message = _ref.message,
      props = _objectWithoutProperties(_ref, ["message"]);

  return /*#__PURE__*/_react["default"].createElement(Message, _extends({
    padding: "16px",
    width: "100%",
    font: "--font-base",
    "font-style": "italic",
    color: "--color-grey",
    "background-color": "--color-light",
    border: "1px dashed --color-lightD2",
    "box-sizing": "border-box"
  }, props), message || 'Some Text');
};

var _default = (0, _atomize["default"])(ComponentNotice)({
  name: 'Component Notice',
  propInfo: {
    message: {
      title: 'Message',
      control: 'input',
      type: 'text',
      weight: 1
    }
  }
});

exports["default"] = _default;